import { selectIsUnlockedForSpace } from 'reducers/selectors';
import { useAppSelector } from 'store/hooks';
/**
 * Prefer the use of use useRequiredTierCallback for callbacks
 */
export const useIsTierUnlockedForSpace = (tier) => {
    const isUnlockedForSpace = useAppSelector((store) => selectIsUnlockedForSpace(store, tier));
    return isUnlockedForSpace;
};
